import axios from "../store/axios";

const url = process.env.VUE_APP_API_URL;

export default {
  state: {
    allStates: [],
    lgas: [],
    lgasOfOrigin: [],
    lgasOfResidence: [],
    countries: [],
    merchants: [],
    institutions: [],
    stateLoading: false,
    lgaLoading: false,
    products: [
      "transfer",
      "mtnvtu",
      "airtelvtu",
      "glovtu",
      "9mobilevtu",
      "mtndata",
      "airteldata",
      "glodata",
      "9mobiledata",
      "ekedc",
      "ikedc",
      "ibedc",
      "eedc",
      "kedco",
      "phedc",
      "aedc",
      "jedc",
      "kadec",
      "bedc",
      "multichoice",
      "startimes",
      "bvn_basic",
      "bvn_advance",
      "aml_individual",
      "aml_business",
      "tin",
      "cac_basic",
      "cac_advance",
      "nin_basic",
      "nin_advance",
    ],
    providers: [
      "monnify",
      "capricorn",
      "vfd",
      "verifyMe",
      "dojah",
      "identityPass",
      "nibss",
      "globus",
    ],
  },
  actions: {
    getStates({ commit }) {
      commit("setStateLoading", true);
      axios
        .get(`${url}/all-states`)
        .then((res) => {
          const { data } = res;
          commit("setStateLoading", false);
          commit("setAllStates", data);
        })
        .catch((err) => {
          commit("setNotification", {
            type: "danger",
            message: "Unable to Fetch States",
          });
          commit("setStateLoading", false);
        });
    },
    getLgas({ commit }, data) {
      commit("setLgaLoading", true);
      axios
        .get(`${url}/lgas/${data}`)
        .then((res) => {
          const { data } = res;
          commit("setLgaLoading", false);
          commit("setLga", data);
          commit("setLgasOfOrigin", data);
        })
        .catch((err) => {
          commit("setNotification", {
            type: "danger",
            message: `Unable to Fetch Lga's`,
          });
          commit("setLgaLoading", false);
        });
    },
    getCountries({ commit }) {
      commit("setLoading", true);
      axios
        .get(`${url}/countries`)
        .then((res) => {
          const { data } = res;
          commit("setLoading", false);
          commit("setCountries", data);
        })
        .catch((err) => {
          commit("setNotification", {
            type: "danger",
            message: `Unable to Fetch Country`,
          });
          commit("setLoading", false);
        });
    },
    getMerchants({ commit }) {
      commit("setLoading", true);
      axios
        .get(`${url}/merchants`)
        .then((res) => {
          const { data } = res;
          commit("setLoading", false);
          commit("setMerchants", data);
        })
        .catch((err) => {
          commit("setNotification", {
            type: "danger",
            message: `Unable to Fetch Merchants`,
          });
          commit("setLoading", false);
        });
    },
    getInstitutions({ commit }) {
      commit("setLoading", true);
      axios
        .get(`${url}/institutions`)
        .then((res) => {
          const { data } = res;
          commit("setLoading", false);
          commit("setInstitutions", data);
        })
        .catch((err) => {
          commit("setNotification", {
            type: "danger",
            message: `Unable to Fetch Institutions`,
          });
          commit("setLoading", false);
        });
    },
  },
  mutations: {
    setLgaLoading(state, payload) {
      state.lgaLoading = payload;
    },
    setStateLoading(state, payload) {
      state.stateLoading = payload;
    },
    setAllStates(state, payload) {
      state.allStates = payload.allStates;
    },
    setLga(state, payload) {
      state.lgas = payload.lgas.locals;
    },
    setLgasOfOrigin(state, payload) {
      state.lgasOfOrigin = payload.lgas.locals;
    },
    setLgasOfResidence(state, payload) {
      state.lgasOfResidence = payload.lgas.locals;
    },
    setCountries(state, payload) {
      state.countries = payload.Countries;
    },
    setMerchants(state, payload) {
      state.merchants = payload.merchants;
    },
    setInstitutions(state, payload) {
      state.institutions = payload.institutions;
    },
  },
};
